import React, { ReactElement, useState } from "react";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import styled from "styled-components";
import { useTranslation } from "@coworker/locales";
interface HalfSheetProps {
  title: string;
  children: React.ReactNode;
  trigger: React.ReactNode;
  isFullWidth?: boolean | undefined;
  header?: ReactElement | null;
  footer?: ReactElement | null;
}

const HeaderWrapper = styled(FixaModalHeader)`
  border-bottom: 1px solid #dfdfdf;
`;

const FullWidthBody = styled(FixaModalBody)`
  width: 100%;
  padding: 0;
`;

export const SimpleHalfSheet: React.FC<HalfSheetProps> = ({
  title,
  children,
  trigger,
  isFullWidth = false,
  header,
  footer,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [inTransition, setInTransition] = useState(false);
  const { t } = useTranslation();

  // Delay the close state change for 200ms to show the close animation
  const defaultHandleToggle = () => {
    if (isOpen) {
      setInTransition(true);
      setIsOpen(false);
      setTimeout(() => setInTransition(false), 200);
    } else {
      setIsOpen(true);
    }
  };

  if (!isOpen && !inTransition)
    return <div onClick={defaultHandleToggle}>{trigger}</div>;

  const BodyComponent = isFullWidth ? FullWidthBody : FixaModalBody;
  return (
    <>
      {trigger}
      <FixaModal visible={isOpen} handleCloseBtn={defaultHandleToggle}>
        <FixaSheets
          alignment="right"
          preserveAlignment={false}
          size="small"
          fullSize
          header={
            <>
              <HeaderWrapper
                title={t(title)}
                floating={false}
                closeBtnClick={defaultHandleToggle}
              />
              {header ?? <></>}
            </>
          }
          footer={footer ?? null}
        >
          <BodyComponent>{children}</BodyComponent>
        </FixaSheets>
      </FixaModal>
    </>
  );
};
